/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class SavingsPlanRecommendation {
    getFixupPrototypeFunction() { return SavingsPlanRecommendation.fixupPrototype; }

    static newInstance(model: Partial<SavingsPlanRecommendation>): SavingsPlanRecommendation {
        let obj = Object.assign(new SavingsPlanRecommendation(), model);
        SavingsPlanRecommendation.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<SavingsPlanRecommendation>): SavingsPlanRecommendation {
        if (!model) return null;
        return SavingsPlanRecommendation.newInstance(<SavingsPlanRecommendation> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: SavingsPlanRecommendation) {
        if (!obj) return;

        models.SavingsPlanRecommendation.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: SavingsPlanRecommendation): boolean {
        Object.setPrototypeOf(obj, SavingsPlanRecommendation.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.usage_hours === undefined) {
            this.usage_hours = 0;
        }
        if (this.commitment_amount === undefined) {
            this.commitment_amount = 0;
        }
        if (this.savings_percentage === undefined) {
            this.savings_percentage = 0;
        }
        if (this.savings_amount === undefined) {
            this.savings_amount = 0;
        }
        if (this.utilization_percentage === undefined) {
            this.utilization_percentage = 0;
        }
        if (this.cost_without_recommendation === undefined) {
            this.cost_without_recommendation = 0;
        }
        if (this.cost_with_recommendation === undefined) {
            this.cost_with_recommendation = 0;
        }
        if (this.number_of_plans === undefined) {
            this.number_of_plans = 0;
        }
    }

    /**
     * Recommendation ID
     */
    recommendation_id: string;

    /**
     * Associated service account ID
     */
    service_account_id: string;

    /**
     * Type of savings plan
     */
    plan_type: string;

    /**
     * Payment option
     */
    payment_option: string;

    /**
     * Scope of the recommendation
     */
    recommendation_scope: string;

    /**
     * Historical usage window used for the recommendation
     */
    lookback_period: string;

    /**
     * Usage hours considered
     */
    usage_hours: number;

    /**
     * Plan term
     */
    term: string;

    /**
     * Commitment granularity
     */
    commitment_granularity: string;

    /**
     * Recommended committed spend per hour
     */
    commitment_amount: number;

    /**
     * Estimated savings percentage
     */
    savings_percentage: number;

    /**
     * Estimated savings amount
     */
    savings_amount: number;

    /**
     * Projected utilization percentage
     */
    utilization_percentage: number;

    /**
     * On-demand cost without the recommendation
     */
    cost_without_recommendation: number;

    /**
     * Projected cost with the recommendation applied
     */
    cost_with_recommendation: number;

    /**
     * Currency of monetary values
     */
    currency: string;

    /**
     * Number of plans recommended
     */
    number_of_plans: number;

    /**
     * Instance family (AWS compute plans)
     */
    instance_family: string;

}
